// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__18LTG","validationTips":"StatementDescriptor_validationTips__1lz3p"};